<template>
  <section>
    <output v-show="isDebug">{{ JSON.stringify(posteriorStroke) }} </output>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="595"
      height="340"
      viewBox="0 0 595 340"
      fill="none"
    >
      <rect width="595" height="340" fill="url(#pattern0_11_9)" />
      <g id="OL">
        <path
          @click="selected('OL')"
          :class="posteriorStroke.includes('OL') ? 'selected' : ''"
          d="M152 203L136 191H131L103 207L106 225L111 246L120 252L136 246L149 235L158 231L167 215L152 203Z"
          fill="#90EE90"
          stroke="black"
        />
      </g>
      <path
        @click="selected('M')"
        :class="posteriorStroke.includes('M') ? 'selected' : ''"
        fill="red"
        d="M293.5 147L287 142.5H285L280.5 149L278.5 159L285 165V169L289.5 172.5L295 175.5L296.5 172.5H301L304.5 175.5L306.5 174L307.5 169L311 163.5H317.5V150.5L311 142.5L304.5 144.5L298.5 155.5L293.5 147Z"
        stroke="black"
      />

      <path
        @click="selected('T')"
        :class="posteriorStroke.includes('T') ? 'selected' : ''"
        fill="#235284"
        d="M117.5 144L109 140.5V156L111 160.5L119.5 169L129.5 177.5H133V165.5L129.5 160.5L124 151.5L117.5 144Z"
        stroke="black"
      />
      <path
        @click="selected('P')"
        :class="posteriorStroke.includes('P') ? 'selected' : ''"
        fill="#ADD8E6"
        d="M481 150L477 156V165L484 173.5H508L513 165L514.5 156L508 147.5L499.5 145H486L481 150Z"
        stroke="black"
      />
      />

      <path
        @click="selected('C')"
        :class="posteriorStroke.includes('C') ? 'selected' : ''"
        fill="orange"
        d="M537.5 170L527.5 168H519L515 171L513 173.5L506 179V188L504 205V220.5V228L508 235L513 238.5L527.5 237L541.5 230.5L552 223L555 217.5L561 205L564 198.5C565.333 196.5 570.441 190.661 568 187C567 185.5 563.333 181.5 561 181.5L553 179L537.5 170Z"
        stroke="black"
      />
    </svg>
  </section>
</template>

<script setup lang="ts">
import {
  Contexts,
  CurrentCaseServiceInterface,
  getContainer,
  getContext,
  Helpers,
  NamedBindings,
  ApplicationEvents,
  Version,
  CoreConfiguration,
} from '@dandelion/core';
import { onBeforeMount, ref, Ref } from 'vue';
import { isEqual } from 'lodash';

const props = defineProps<{
  context: string;
  fullName: string;
  id: string;
}>();

const coreConfiguration = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CoreConfiguration
) as CoreConfiguration;
const currentCaseService = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CurrentCaseService
) as CurrentCaseServiceInterface;

const posteriorStroke = ref<Array<string>>([]);
const isDebug = coreConfiguration.debug;

async function selected(selected: string) {
  const model = (await useCurrentContext(props!.context)).model;

  if (posteriorStroke.value.includes(selected)) {
    posteriorStroke.value = posteriorStroke.value.filter(
      (item: string) => item !== selected
    );
  } else {
    posteriorStroke.value.push(selected);
  }
  Helpers.setObjByPath(props.fullName, model, posteriorStroke.value);
}

onBeforeMount(async () => {
  const model = (await useCurrentContext(props!.context)).model;
  const posteriorStrokeFromModel = Helpers.getObjByPath(props.fullName, model);

  if (!posteriorStroke.value) {
    return;
  }
  posteriorStroke.value = posteriorStrokeFromModel ?? [];
});

async function useCurrentContext(context = Contexts.DEFAULT) {
  let crfVersions: Readonly<Ref<ReadonlyMap<string, Version>>> = ref(new Map());
  try {
    crfVersions = ref(currentCaseService.getCrfVersions());
  } catch (e) {
    // TODO: maybe remove error thrown, there are cases when no version is available
    // e.g. the context is not set, no current patient etc.
  }
  const model = await currentCaseService.getModel();
  const keyForReRender = ref(0);

  getContext(context).addEventListener(
    ApplicationEvents.CaseOpenedForEditing,
    async () => {
      const currentCrfVersions = currentCaseService.getCrfVersions();
      if (!isEqual(currentCrfVersions, crfVersions)) {
        crfVersions = currentCrfVersions;
      }
      keyForReRender.value = keyForReRender.value + 1;
    }
  );
  return { keyForReRender, crfVersions, model };
}
</script>
<style scoped>
path {
  opacity: 0.15;
}

path:hover {
  cursor: pointer;
  opacity: 0.3;
}

.selected {
  cursor: pointer;
  opacity: 0.8 !important;
}
</style>
